<template>
  <SfTable>
    <SfTableHeading>
      <SfTableHeader v-for="header in tableHeaders" :key="header">
        {{ header }}
      </SfTableHeader>
    </SfTableHeading>
    <SfTableRow v-for="(row, key) in products" :key="key">
      <SfTableData v-for="(data, index) in row" :key="index">
        {{ data }}
      </SfTableData>
    </SfTableRow>
  </SfTable>
</template>
<script>
import { SfTable } from '@storefront-ui/vue/';
import { config } from '@/modules/core';

export default {
  name: 'ProductsTable',
  mixins: [config],
  components: {
    SfTable,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tableHeaders: [
        this.$t('Name'),
        this.$t('Sku'),
        this.$t('Qty'),
        this.$t('Gross Price'),
        this.$t('Discount'),
        this.$t('Price without discount'),
        this.$t('Total Price'),
      ],
    };
  },
  computed: {
    products() {
      return this.items.map((product) => [
        product.ProductName,
        product.Sku,
        product.Quantity,
        this.currencyFormatter().format(product.UnitPrice),
        `${product.Discount}%`,
        this.currencyFormatter().format(product.UnitPriceWithoutDiscount),
        this.currencyFormatter().format(product.SubTotal),
      ]);
    },
  },
};
</script>
